// test2124
(2124 && 0);
